<template>
  <market-card class="market-booking">
    <div class="market-booking__body">
      <h2 class="market-booking__title">{{ $t('pages.login.user.book_now_title') }}</h2>
      <p class="market-booking__text">{{ $t('pages.login.user.book_now_text') }}</p>
      <div class="market-booking__logos">
        <b-img
          :src="require('@base/assets/images/svg/visa-logo.svg')"
          width="48"
          height="24"
          alt="Visa"
        />
        <b-img
          :src="require('@base/assets/images/svg/mastercard-logo.svg')"
          width="48"
          height="24"
          alt="Mastercard"
        />
      </div>
    </div>
    <b-button
      variant="success"
      size="lg"
      class="market-booking__button"
      @click="$router.push({ name: 'create-booking' })"
    >
      <b-icon icon="calendar-check" class="mr-2" />
      {{ $t('navigation.customer.create_new_booking') }}
    </b-button>
  </market-card>
</template>

<script>
  import MarketCard from '@base/components/market/MarketCard.vue'

  export default {
    name: 'MarketBookingCard',

    components: {
      MarketCard,
    },
  }
</script>

<style scoped>
  .market-booking {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 1rem;
    border-left: 4px solid var(--ui-brand);
  }

  .market-booking__body {
    flex: 1 1 260px;
    min-width: 0;
  }

  .market-booking__title {
    font-size: 1.25rem;
    font-weight: 700;
    color: var(--ui-ink);
    margin-bottom: 0.375rem;
  }

  .market-booking__text {
    color: var(--ui-muted);
    margin-bottom: 0.5rem;
  }

  .market-booking__logos {
    display: flex;
    gap: 0.5rem;
    align-items: center;
  }

  .market-booking__button {
    flex: 0 0 auto;
  }

  @media (max-width: 575.98px) {
    .market-booking__button {
      width: 100%;
    }
  }
</style>
